import { useCallback, useEffect, useState } from "react";
import { Check, X, Trash2, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { api, catName, imgSrc, errMsg } from "../../lib/api";

const FILTERS = [
  { id: "pending", label: "Pendentes" },
  { id: "approved", label: "Aprovadas" },
  { id: "rejected", label: "Recusadas" },
];

const Action = ({ onClick, icon: Icon, testId, cls }) => (
  <button data-testid={testId} onClick={onClick} className={`flex flex-1 items-center justify-center rounded-full border py-2 transition-colors ${cls}`}><Icon className="h-4 w-4" /></button>
);

export const AdminPhotos = () => {
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/admin/photos", { params: { status } }).then((r) => setItems(r.data)), [status]);
  useEffect(() => {
    setItems(null);
    load();
  }, [load]);

  const act = async (p, s) => {
    try {
      await api.post(`/admin/photos/${p.id}/status`, { status: s });
      toast.success({ approved: "Foto aprovada", rejected: "Foto recusada", removed: "Foto removida", pending: "Foto voltou para análise" }[s]);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <h2 className="font-display text-3xl font-black uppercase">Moderação de fotos</h2>
        <div className="flex gap-2">
          {FILTERS.map((f) => (
            <button key={f.id} data-testid={`admin-photos-filter-${f.id}`} onClick={() => setStatus(f.id)} className={`rounded-full border px-4 py-2 font-mono-tech text-xs uppercase ${status === f.id ? "border-cyan-400 bg-cyan-400 text-black" : "border-white/15 text-slate-300"}`}>{f.label}</button>
          ))}
        </div>
      </div>
      {items?.length === 0 && <p className="py-12 text-center text-slate-400" data-testid="admin-photos-empty">Nada por aqui.</p>}
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {(items || []).map((p) => (
          <div key={p.id} className="glass overflow-hidden rounded-xl" data-testid={`admin-photo-${p.id}`}>
            <img src={imgSrc(p.src)} alt={p.title} className="h-48 w-full object-cover" />
            <div className="p-4">
              <p className="truncate font-display text-lg font-bold uppercase">{p.title}</p>
              <p className="truncate text-xs text-slate-400">{p.user_name} · {catName(p.category)}{p.is_free ? " · grátis" : ""}</p>
              <div className="mt-3 flex gap-2">
                {status !== "approved" && <Action testId={`admin-btn-approve-photo-${p.id}`} icon={Check} onClick={() => act(p, "approved")} cls="border-lime-400/40 text-lime-300 hover:bg-lime-400/10" />}
                {status !== "rejected" && <Action testId={`admin-btn-reject-photo-${p.id}`} icon={X} onClick={() => act(p, "rejected")} cls="border-yellow-400/40 text-yellow-300 hover:bg-yellow-400/10" />}
                {status !== "pending" && <Action testId={`admin-btn-pending-photo-${p.id}`} icon={Undo2} onClick={() => act(p, "pending")} cls="border-white/15 hover:border-cyan-400" />}
                <Action testId={`admin-btn-remove-photo-${p.id}`} icon={Trash2} onClick={() => act(p, "removed")} cls="border-red-500/40 text-red-400 hover:bg-red-500/10" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
